import { createSelector } from 'reselect'

import { PROPERTIES_STATE } from './constants'

import { getLanguage } from 'src/comps/Page/selectors'
import { getProperty } from 'client/contexts/Property/selectors'
import { getSearch } from 'src/effects/Search/selectors'
import { upHighlighted } from 'src/effects/Properties/utils'

export const getCount = state => state[PROPERTIES_STATE]?.count
export const getDistributionPriceRange = state => state[PROPERTIES_STATE]?.distribution
export const getIsFetching = state => state[PROPERTIES_STATE]?.isFetching
export const getProperties = state => state[PROPERTIES_STATE]?.properties

export const getPropertiesApiParams = createSelector(
  [getSearch, getLanguage],
  ({ children, checkIn, checkOut, ...otherSearchParams }, language) => ({
    checkIn,
    checkOut,
    children,
    language,
    ...otherSearchParams,
  })
)

export const getPropertiesAndHighlighted = createSelector(
  [getProperties, getProperty],
  (properties, property) => {
    return upHighlighted({ properties, property })
  }
)
